module.exports = __webpack_public_path__ + "img/br28.535c645.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br28.jpg
// module id = SZQx
// module chunks = 0